import React, { useContext, useEffect, useState } from "react";
import { Button, message, Modal, Input, Space, Tag } from "antd";
import CustomTable from "../../components/CustomTable";
import useApi from "../../hooks/useApi";
import { AppStateContext } from "../../context/AppContext";
import { getCitiesList } from "../../constants/API/API";
import { EditOutlined, ExclamationCircleOutlined, EyeOutlined, } from "@ant-design/icons";
import AddCity from "./AddCity";
import UpdateCity from "./UpdateCity";
import ViewCity from "./ViewCity";
import useFilter from "../../hooks/useFilter";
import useRequest from "../../hooks/useRequest";
import { Severty, ShowToast } from "../../helper/toast";
import useDebounce from "../../hooks/useDebounce";
import moment from "moment";

const { Search } = Input;

const CityIndex = () => {
  const { setPageHeading } = useContext(AppStateContext);
  setPageHeading("City Management");

  const { confirm } = Modal;
  const { request } = useRequest();
  const [loading, setLoading] = useState(true);
  const [refresh, setRefresh] = useState(new Date().getTime());
  const [data, setData] = useState([]);
  const [totalDocs, setTotalDocs] = useState(0);
  const [addModal, setAddModal] = useState(false);
  const [editModal, setEditModal] = useState(false);
  const [viewModal, setViewModal] = useState(false);
  const [selectedBanner, setSelectedBanner] = useState();
  const [filters, setFilters] = useFilter({
    sortField: "createdOn",
    sort: "desc",
    name: "",
  });

  const handleViewClick = (record) => {
    setViewModal(true);
    setSelectedBanner(record);
  };

  const handleEditClick = (record) => {
    setEditModal(true);
    setSelectedBanner(record);
  };

  const showConfirm = (record) => {
    setTimeout(() => {
      confirm({
        icon: <ExclamationCircleOutlined />,
        content: <Button>Are you sure you want change the status ? </Button>,
        onOk() {
          statusChange(record);
        },
        onCancel() {
          console.log("Cancel");
        },
      });
    }, 5);
  };

  const statusChange = (record) => {
    setLoading(true);
    request({
      url: `/admin/city/status-change/${record}`,
      method: "PUT",
      onSuccess: (data) => {
        setLoading(false);
        ShowToast("status Changed Successfully", Severty.SUCCESS);
        setRefresh((prev) => !prev);
      },
      onError: (error) => {
        console.log(error);
        ShowToast(error, Severty.ERROR);
      },
    });
  };

  useApi({
    callback: getCitiesList,
    payload: { ...filters },
    dependencies: [refresh, filters],
    shouldCallApi: true,
    setLoading,
    onSuccess: (data) => {
      setData(data?.list || []);
      setTotalDocs(data?.totalDocs || 0);
      setLoading(false);
    },
    onError: () => {
      setLoading(false);
    },
  });

  const columns = [
    {
      title: "City Name",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Status",
      dataIndex: "isActive",
      key: "isActive",
      filters: [
        { text: "Active", value: true },
        { text: "Inactive", value: false },
      ],
      render: (_, { isActive, _id }) => {
        let color = isActive ? "green" : "red";
        return (
          <Tag
            color={color}
            onClick={() => showConfirm(_id)}
            style={{
              cursor: "pointer",
              userSelect: "none",
            }}
            className="status-tag"
          >
            {isActive ? "Active" : "Inactive"}
          </Tag>

        );
      },
    },
    {
      title: "Created At",
      dataIndex: "createdAt",
      key: "createdAt",
      render: (text) => (text ? moment(text).format("ll") : "-"),
    },
    {
      title: "Actions",
      key: "actions",
      render: (_, record) => (
        <Space size="middle">
          <Button
            type="primary"
            onClick={() => handleViewClick(record)}
            icon={<EyeOutlined />}
            title="View"
          />

          <Button
            type="primary"
            onClick={() => handleEditClick(record)}
            icon={<EditOutlined />}
            title="Edit"
          />
        </Space>
      ),
    },
  ];

  return (
    <>
      <CustomTable
        data={data}
        addFn={() => setAddModal(true)}
        loading={loading}
        columns={columns}
        filters={filters}
        setFilters={setFilters}
        totalDocs={totalDocs}
        searchField={["name"]}
        searchPlaceholder={"Search by Name"}
        hideAddButton
        fields={{ search: true, range: false }}
        onSearch={(value) => setFilters((prev) => ({ ...prev, search: value }))}
      />

      {addModal && (
        <AddCity
          visible={addModal}
          setVisible={setAddModal}
          refresh={() => setRefresh((x) => !x)}
        />
      )}
      {editModal && (
        <UpdateCity
          editVisible={editModal}
          setEditVisible={setEditModal}
          selectedBelt={selectedBanner}
          refresh={() => setRefresh((x) => !x)}
        />
      )}
      {viewModal && (
        <ViewCity
          viewVisible={viewModal}
          setViewVisible={setViewModal}
          selectedBelt={selectedBanner}
        />
      )}
    </>
  );
};

export default CityIndex;
